module.exports = __webpack_public_path__ + "media/images/guideline/B04-51c4de9fdf594566642f8df85965387c.jpg";